const resources = [
  {
    category: "Passport Photo Locations",
    icon: "ri-camera-line",
    items: [
      { name: "Walgreens – Grand Forks", detail: "Multiple locations in Grand Forks" },
      { name: "CVS Photo – Grand Forks", detail: "Passport photos while you wait" },
      { name: "Walmart – Grand Forks", detail: "2101 32nd Ave S, Grand Forks — budget option" },
      { name: "UND Campus Store", detail: "UND campus passport photo services" },
    ],
  },
  {
    category: "North Dakota DMV",
    icon: "ri-id-card-line",
    items: [
      { name: "ND Dept. of Transportation", detail: "nddot.gov — driver licenses and state IDs" },
      { name: "Grand Forks Driver License", detail: "1907 N 45th St, Grand Forks" },
      { name: "ND REAL ID Info", detail: "nddot.gov/dmv/license-id/real-id" },
      { name: "MN DMV – East Grand Forks", detail: "Serves Minnesota border residents" },
    ],
  },
  {
    category: "Grand Forks Airport Info",
    icon: "ri-plane-line",
    items: [
      { name: "Grand Forks International Airport", detail: "3240 Airport Dr, Grand Forks, ND 58203" },
      { name: "Airport Code", detail: "GFK — northeast North Dakota hub" },
      { name: "Direct Flights", detail: "Minneapolis, Chicago, Denver, Las Vegas" },
      { name: "TSA PreCheck", detail: "Available at GFK for faster security" },
    ],
  },
];

const vitalRecords = [
  {
    icon: "ri-user-heart-line",
    label: "Birth Certificates",
    desc: "North Dakota Department of Health — Vital Records. Order online, by mail, or in person at the Grand Forks County office.",
    url: "https://www.hhs.nd.gov/vital",
  },
  {
    icon: "ri-heart-pulse-line",
    label: "Death Certificates",
    desc: "Certified copies available through ND Vital Records. Required for some passport applications.",
    url: "https://www.hhs.nd.gov/vital",
  },
  {
    icon: "ri-links-line",
    label: "Marriage Certificates",
    desc: "Grand Forks County Recorder or ND Vital Records. Needed for passport name change after marriage.",
    url: "https://www.grandforksgov.com/",
  },
  {
    icon: "ri-scales-3-line",
    label: "Divorce Decrees",
    desc: "Grand Forks County District Court. Contact the Clerk of Court for certified copies of divorce records.",
    url: "https://www.ndcourts.gov/",
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Passport Resources in Grand Forks
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything you need to get your passport ready for travel from the Grand Forks metro area.
          </p>
        </div>

        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {resources.map((r, i) => (
              <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                    <i className={`${r.icon} text-[#1A365D]`}></i>
                  </div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{r.category}</h3>
                </div>
                <ul className="space-y-3">
                  {r.items.map((item, j) => (
                    <li key={j} className="border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                      <p className="font-semibold text-[#1A365D] text-xs">{item.name}</p>
                      <p className="text-gray-400 text-xs mt-0.5">{item.detail}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Birth, Death, Marriage &amp; Divorce Records — Grand Forks</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                If you need a certified copy of your birth certificate for a passport application, a marriage certificate for a name change, or a divorce decree to support your passport correction, here are the official sources for vital records for Grand Forks residents.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                {vitalRecords.map((record, i) => (
                  <a key={i} href={record.url} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                      <i className={`${record.icon} text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{record.label}</p>
                      <p className="text-gray-500 text-xs leading-relaxed mb-1.5">{record.desc}</p>
                      <span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors"><i className="ri-external-link-line text-xs"></i>Get Records</span>
                    </div>
                  </a>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-information-line text-amber-500 mr-1.5"></i>
                  <strong>Don&apos;t see your county?</strong> Visit <a href="https://www.vitalchek.com/" target="_blank" rel="noopener noreferrer" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">VitalChek.com</a> — the official online service for ordering vital records nationwide.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}